import { render, staticRenderFns } from "./course.vue?vue&type=template&id=42d66217&scoped=true"
import script from "./course.vue?vue&type=script&lang=ts"
export * from "./course.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42d66217",
  null
  
)

export default component.exports